var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M6 4h14M6 5h14M4 6h2m14 0h2M4 7h2m14 0h2M2 8h2m18 0h2M2 9h2m18 0h2M2 10h2m18 0h2M2 11h2m18 0h2M2 12h2m18 0h2M2 13h2m18 0h2M2 14h2m18 0h2M2 15h2m18 0h2M2 16h2m16 0h2M2 17h2m16 0h2M4 18h2m4 0h10M4 19h2m4 0h10M4 20h2m2 0h2m-6 1h2m2 0h2m-4 1h2m-2 1h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#feffed",
    d: "M6 6h14M6 7h14M4 8h2M4 9h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e2faff",
    d: "M6 8h14M6 9h14M6 10h14M6 11h14M6 12h2m2 0h2m2 0h2m2 0h2M6 13h2m2 0h2m2 0h2m2 0h2M6 14h14M6 15h14M6 16h4m-4 1h4m-4 1h2m-2 1h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c0c8ea",
    d: "M20 8h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-2 1h2m-12 1h10m-10 1h10M8 18h2m-2 1h2m-4 1h2m-2 1h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5a3ddb",
    d: "M8 12h2m2 0h2m2 0h2M8 13h2m2 0h2m2 0h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.9d834c822253c128b477092fff351918.svg";
export { ForwardRef as ReactComponent };